import React, { useState } from "react"

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"
import { Button } from "@/components/ui/button"

import { MoreHorizontal } from "lucide-react"
import { VerUktKelompok, VerUktKelompokDetail } from "@/types"
import Modal from "@/components/Modal"
import Form from "./Form"
import { useQuery } from "@tanstack/react-query"
import api from "@/lib/axios"
import SkeletonRow from "@/components/SkeletonRow"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { getInitials } from "@/lib/utils"

const getData = async (id_verukt_kelompok: string) => {
  const response = await api.get(
    `/setting/verifikator-ukt/show-peserta-kelompok/${id_verukt_kelompok}`
  )
  return response.data
}

export default function Actions({ row }: { row: VerUktKelompok }) {
  const [selectedRow, setSelectedRow] = useState<VerUktKelompok | null>(null)
  const [showAssignVerifikator, setShowAssignVerifikator] = useState(false)
  const [showListPeserta, setShowListPeserta] = useState(false)

  const { data: dataListPeserta, isPending: isPendingDataListPeserta } =
    useQuery({
      queryKey: ["listPesertaVerifikasi", selectedRow?.id_verukt_kelompok],
      queryFn: () => getData(selectedRow?.id_verukt_kelompok || ""),
      enabled: !!selectedRow?.id_verukt_kelompok,
    })

  return (
    <React.Fragment>
      <div className="flex items-center gap-x-4">
        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button variant="ghost" className="w-8 h-8 p-0">
              <span className="sr-only">Open menu</span>
              <MoreHorizontal className="w-4 h-4" />
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent align="end">
            <DropdownMenuLabel>Actions</DropdownMenuLabel>
            <DropdownMenuItem
              onClick={() => {
                setShowAssignVerifikator(true)
                setSelectedRow(row)
              }}
            >
              Daftarkan Verifikator
            </DropdownMenuItem>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              onClick={() => {
                setShowListPeserta(true)
                setSelectedRow(row)
              }}
            >
              Lihat List Peserta
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>

      <Modal
        show={showAssignVerifikator}
        onClose={() => setShowAssignVerifikator(false)}
      >
        <Form
          selectedRow={selectedRow}
          closeModal={() => setShowAssignVerifikator(false)}
        />
      </Modal>

      <Modal
        show={showListPeserta}
        onClose={() => setShowListPeserta(false)}
        className="lg:w-[50vw] max-h-[90vh] overflow-auto"
      >
        {isPendingDataListPeserta ? (
          <div className="flex flex-col gap-y-3">
            {Array(5)
              .fill(null)
              .map((_, index) => {
                return <SkeletonRow key={index} />
              })}
          </div>
        ) : dataListPeserta?.data && dataListPeserta?.data.length > 0 ? (
          <div>
            <h1 className="font-bold">List Peserta</h1>
            <div className="mt-3 p-5 flex-1 overflow-auto rounded-xl border">
              <table className="table-auto w-full border-collapse border rounded-xl overflow-hidden">
                <thead>
                  <tr>
                    <th className="py-1 px-4 border">No</th>
                    <th className="py-1 px-4 border">Nomor Pendaftaran</th>
                    <th className="py-1 px-4 border">Nama Peseserta</th>
                    <th className="py-1 px-4 border">Foto</th>
                  </tr>
                </thead>
                <tbody>
                  {dataListPeserta?.data?.map(
                    (item: VerUktKelompokDetail, index: number) => {
                      return (
                        <tr key={item?.pendaftaran?.data_siswa?.id_data_siswa}>
                          <td className="py-1 px-4 border">{index + 1}</td>
                          <td className="py-1 px-4 border">
                            {item.pendaftaran?.nomor_pendaftaran}
                          </td>
                          <td className="py-1 px-4 border">
                            {item.pendaftaran?.data_siswa?.nama_lengkap}
                          </td>
                          <td className="py-1 px-4 border">
                            <Avatar className="mb-5 mx-auto w-16 h-16">
                              <AvatarImage
                                src={
                                  item.pendaftaran?.data_siswa?.path_foto || ""
                                }
                                alt={"foto"}
                              />
                              <AvatarFallback>
                                {getInitials(
                                  item.pendaftaran?.data_siswa?.nama_lengkap ||
                                    ""
                                )}
                              </AvatarFallback>
                            </Avatar>
                          </td>
                        </tr>
                      )
                    }
                  )}
                </tbody>
              </table>
            </div>
          </div>
        ) : (
          "List peserta tidak ditemukan."
        )}
      </Modal>
    </React.Fragment>
  )
}
